(function () {
  class BundleSalesCart extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.section = this.closest(".bundle-sales");
      this.labels = {};
      this.handleClick = this.handleClick.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
    }

    connectedCallback() {
      this.section = this.closest(".bundle-sales");
      this.labels = {
        itemsOne: this.section?.dataset.itemsOneLabel || "",
        itemsOther: this.section?.dataset.itemsOtherLabel || "",
        addProducts: this.section?.dataset.addProductsLabel || "",
        error: this.section?.dataset.errorLabel || "",
      };
      this.addEventListener("click", this.handleClick);
      this.mediaQuery = window.matchMedia("(max-width: 749px)");
      this.mediaQuery.addEventListener?.("change", this.handleViewportChange);
      this.handleViewportChange();
      if (this.section?.dataset.defaultSelect === "true") {
        const firstAvailable = this.section.querySelector(
          "[data-add-product]:not(:disabled)",
        );
        if (firstAvailable) this.addProduct(firstAvailable);
      }
      this.render();
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.mediaQuery?.removeEventListener?.(
        "change",
        this.handleViewportChange,
      );
      this.viewportObserver?.disconnect();
      window.removeEventListener("scroll", this.handleDockScroll);
      window.removeEventListener("resize", this.handleDockScroll);
      if (this.dockFrame) window.cancelAnimationFrame(this.dockFrame);
    }

    handleViewportChange() {
      this.viewportObserver?.disconnect();
      this.viewportObserver = null;
      window.removeEventListener("scroll", this.handleDockScroll);
      window.removeEventListener("resize", this.handleDockScroll);
      if (this.dockFrame) window.cancelAnimationFrame(this.dockFrame);
      this.dockFrame = null;

      if (!this.section || !this.mediaQuery?.matches) {
        this.classList.remove("is-docked");
        return;
      }

      const updateDockedState = () => {
        this.dockFrame = null;
        const productRegion =
          this.section.querySelector(".bundle-sales__content") || this.section;
        const rect = productRegion.getBoundingClientRect();
        // 可调整：0.5 表示产品区域顶部进入屏幕高度的 50% 后显示。
        const visibleAfterRatio = 0.5;
        const hasReachedShowPoint =
          rect.top <= window.innerHeight * (1 - visibleAfterRatio);
        // 可调整：0.5 表示产品区域划出 50% 后隐藏底部购物车。
        const hiddenAfterRatio = 0.5;
        const hasScrolledPastHidePoint =
          rect.top <= -(rect.height * hiddenAfterRatio);
        const isDocked =
          hasReachedShowPoint && rect.bottom > 0 && !hasScrolledPastHidePoint;
        this.classList.toggle("is-docked", isDocked);

        if (!isDocked && this.classList.contains("is-expanded")) {
          this.classList.remove("is-expanded");
          this.querySelector(".bundle-sales__cart-toggle")?.setAttribute(
            "aria-expanded",
            "false",
          );
        }
      };

      this.handleDockScroll = () => {
        if (!this.dockFrame)
          this.dockFrame = window.requestAnimationFrame(updateDockedState);
      };
      window.addEventListener("scroll", this.handleDockScroll, {
        passive: true,
      });
      window.addEventListener("resize", this.handleDockScroll);
      updateDockedState();
    }

    handleClick(event) {
      const action = event.target.closest(
        "[data-add-all], [data-cart-action], .bundle-sales__cart-toggle",
      );
      if (!action) return;
      if (action.matches(".bundle-sales__cart-toggle")) {
        const expanded = this.classList.toggle("is-expanded");
        action.setAttribute("aria-expanded", String(expanded));
      } else if (action.dataset.addAll !== undefined) {
        this.addAll();
      } else {
        const index = Number(action.dataset.index);
        if (!this.items[index]) return;
        if (action.dataset.remove !== undefined)
          this.updateQuantity(index, -this.items[index].quantity);
        else this.updateQuantity(index, Number(action.dataset.delta));
      }
    }

    addProduct(button) {
      if (button.disabled) return;
      const variantId = String(button.dataset.variantId);
      if (!variantId) return;
      const item = this.items.find((entry) => entry.variantId === variantId);
      if (item) return;
      else
        this.items.push({
          variantId,
          quantity: 1,
          title: button.dataset.productTitle,
          price: Number(button.dataset.productPrice) || 0,
          comparePrice: Number(button.dataset.productComparePrice) || 0,
          image: button.dataset.productImage,
        });
      this.render();
      this.dispatchEvent(
        new CustomEvent("bundle-sales:update", { bubbles: true }),
      );
    }

    updateQuantity(index, delta) {
      if (!this.items[index]) return;
      this.items[index].quantity += delta;
      if (this.items[index].quantity <= 0) this.items.splice(index, 1);
      this.render();
      this.dispatchEvent(
        new CustomEvent("bundle-sales:update", { bubbles: true }),
      );
    }

    render() {
      const totalQuantity = this.items.reduce(
        (sum, item) => sum + item.quantity,
        0,
      );
      const total = this.items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0,
      );
      const discount = this.getDiscount(totalQuantity, total);
      const itemContainer = this.querySelector("[data-items]");
      if (itemContainer)
        itemContainer.innerHTML = this.items.length
          ? this.items
              .map(
                (item, index) => `<div class="bundle-sales__item">
            <img src="${item.image}" alt="">
            <span class="bundle-sales__item-title">${this.escape(item.title)}</span>
            <div class="bundle-sales__item-actions">
              <div class="bundle-sales__quantity">
                <span class="bundle-sales__quantity-value">${item.quantity}</span>
                <span class="bundle-sales__quantity-arrows">
                  <button type="button" data-cart-action data-index="${index}" data-delta="1" aria-label="Increase quantity">
                    <svg aria-hidden="true" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.5L6 4.5L3 7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </button>
                  <button type="button" data-cart-action data-index="${index}" data-delta="-1" aria-label="Decrease quantity">
                    <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 4.5L6 7.5L3 4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </button>
                </span>
              </div>
              <button type="button" class="bundle-sales__remove" data-cart-action data-remove data-index="${index}">Remove</button>
            </div>
          </div>`,
              )
              .join("")
          : `<div class="bundle-sales__empty">${this.escape(this.labels.addProducts)}</div>`;
      this.querySelectorAll("[data-item-count]").forEach((element) => {
        element.textContent = this.formatItemCount(totalQuantity);
      });
      this.querySelectorAll("[data-total]").forEach((element) => {
        element.textContent = this.money(total - discount);
      });
      this.querySelectorAll("[data-discount-total]").forEach((element) => {
        element.textContent = this.money(discount);
      });
      this.querySelectorAll("[data-discount-percent]").forEach((element) => {
        element.textContent = `${discount ? this.getDiscountPercent(totalQuantity) : 0}%`;
      });
      this.querySelectorAll("[data-cart-summary]").forEach((element) => {
        element.textContent = totalQuantity
          ? this.formatItemCount(totalQuantity)
          : this.labels.addProducts;
      });
      const progress = this.querySelector("[data-progress]");
      const secondQuantity =
        Number(this.section?.dataset.secondDiscountQuantity) || 0;
      if (progress) {
        const progressPercent =
          secondQuantity > 0
            ? Math.min(100, (totalQuantity / secondQuantity) * 100)
            : 0;
        window.requestAnimationFrame(() => {
          progress.style.width = `${progressPercent}%`;
        });
      }
      this.syncProductButtons();
    }

    getDiscount(quantity, total) {
      return (total * this.getDiscountPercent(quantity)) / 100;
    }
    getDiscountPercent(quantity) {
      const firstQuantity =
        Number(this.section?.dataset.firstDiscountQuantity) || 0;
      const secondQuantity =
        Number(this.section?.dataset.secondDiscountQuantity) || 0;
      const first = Number(this.section?.dataset.firstDiscountPercentage) || 0;
      const second =
        Number(this.section?.dataset.secondDiscountPercentage) || 0;
      return secondQuantity && quantity >= secondQuantity
        ? second
        : firstQuantity && quantity >= firstQuantity
          ? first
          : 0;
    }
    formatItemCount(quantity) {
      const usesSingularLabel = quantity <= 1;
      const label = usesSingularLabel
        ? this.labels.itemsOne
        : this.labels.itemsOther;
      if (!label || label.includes("sections."))
        return `${quantity} ${usesSingularLabel ? "Item" : "Items"}`;
      return label.replace(/\b0\b|\b1\b|{{\s*count\s*}}/, quantity);
    }
    money(value) {
      return Shopify.formatMoney(value, window.moneyFormat);
    }
    escape(value) {
      const element = document.createElement("span");
      element.textContent = value;
      return element.innerHTML;
    }
    hasVariant(variantId) {
      return this.items.some(
        (item) => String(item.variantId) === String(variantId),
      );
    }
    syncProductButtons() {
      this.section?.querySelectorAll("[data-add-product]").forEach((button) => {
        const soldOut =
          button.dataset.productInventoryPolicy === "deny" &&
          Number(button.dataset.productInventory) <= 0;
        const added = this.hasVariant(button.dataset.variantId);
        const unavailable = soldOut || added;
        button.classList.toggle("is-sold-out", soldOut);
        button.classList.toggle("sold-out", soldOut);
        button.classList.toggle("is-added", !soldOut && added);
        button.classList.toggle("added", !soldOut && added);
        button.dataset.added = String(!soldOut && added);
        button.disabled = unavailable;
        button.toggleAttribute("disabled", unavailable);
        button.setAttribute("aria-disabled", String(unavailable));
        button.textContent = soldOut
          ? "Sold Out"
          : added
            ? "Added"
            : button.dataset.originalLabel || "Add to Cart";
      });
    }

    async addAll() {
      const error = this.querySelector("[data-error]");
      if (!this.items.length) {
        if (error) {
          error.hidden = false;
          error.textContent = this.labels.addProducts;
        }
        return;
      }
      if (error) {
        error.hidden = true;
        error.textContent = "";
      }
      const formData = new FormData();
      this.items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.variantId);
        formData.append(`items[${index}][quantity]`, item.quantity);
      });
      const cart = document.querySelector("cart-drawer, cart-notification");
      const config = window.fetchConfig
        ? fetchConfig("json")
        : { method: "POST", headers: {} };
      // Let the browser add the multipart boundary required by FormData. Keeping
      // fetchConfig's application/json header makes Shopify treat the body as JSON.
      delete config.headers["Content-Type"];
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      config.body = formData;
      if (cart?.getSectionsToRender) {
        formData.append(
          "sections",
          cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(","),
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }
      try {
        const response = await fetch(
          window.routes?.cart_add_url || "/cart/add.js",
          config,
        );
        const responseText = await response.text();
        let data = {};
        if (responseText) {
          try {
            data = JSON.parse(responseText);
          } catch (_) {
            throw new Error(
              this.labels.error || "Unable to add products to cart",
            );
          }
        }
        if (!response.ok)
          throw new Error(
            data.description ||
              data.message ||
              this.labels.error ||
              "Unable to add products to cart",
          );
        if (cart?.renderContents && data.sections) {
          cart.renderContents(data);
          // The drawer's outer empty state controls item and footer visibility.
          cart.classList.remove("is-empty");
        }
        this.items = [];
        this.render();
      } catch (requestError) {
        if (error) {
          error.hidden = false;
          error.textContent =
            requestError.message ||
            this.labels.error ||
            "Unable to add products to cart";
        }
      }
    }
  }

  class BundleSalesSeriesList extends HTMLElement {
    connectedCallback() {
      this.cart =
        this.closest(".bundle-sales")?.querySelector("bundle-sales-cart");
      if (
        !window.loadedBackgroundColorSwatches &&
        typeof window.loadColorSwatches === "function" &&
        this.querySelector("[data-color]")
      )
        window.loadColorSwatches();
      this.querySelectorAll("[data-add-product]").forEach((button) => {
        button.dataset.originalLabel = button.textContent.trim();
      });
      this.onClick = (event) => {
        const dropdownItem = event.target.closest("[data-dropdown-item]");
        if (dropdownItem) {
          event.preventDefault();
          event.stopPropagation();
          this.selectDropdownItem(dropdownItem);
          return;
        }
        const dropdownToggle = event.target.closest("[data-dropdown-toggle]");
        if (dropdownToggle) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleDropdown(dropdownToggle);
          return;
        }
        const addButton = event.target.closest("[data-add-product]");
        if (addButton) {
          event.preventDefault();
          this.cart?.addProduct(addButton);
          return;
        }
        const colorButton = event.target.closest("[data-color-name]");
        if (colorButton) {
          event.preventDefault();
          this.updateColorVariant(colorButton);
          return;
        }
        const scrollButton = event.target.closest("[data-scroll]");
        if (scrollButton) this.scroll(scrollButton);
      };
      this.onChange = (event) => {
        const select = event.target.closest("[data-product-select]");
        if (select?.value)
          this.loadProduct(select.closest("[data-product-card]"), select.value);
      };
      this.onPointerDown = (event) => {
        const track = event.target.closest("[data-track]");
        const interactiveElement = event.target.closest(
          "button, a, select, input, label",
        );
        if (!track || interactiveElement || event.pointerType === "touch")
          return;
        this.drag = { track, x: event.clientX, scrollLeft: track.scrollLeft };
        track.setPointerCapture(event.pointerId);
      };
      this.onPointerMove = (event) => {
        if (this.drag)
          this.drag.track.scrollLeft =
            this.drag.scrollLeft - (event.clientX - this.drag.x);
      };
      this.onPointerUp = () => {
        this.drag = null;
      };
      this.onDocumentClick = () => this.closeDropdowns();
      this.addEventListener("click", this.onClick);
      this.addEventListener("change", this.onChange);
      this.addEventListener("pointerdown", this.onPointerDown);
      this.addEventListener("pointermove", this.onPointerMove);
      this.addEventListener("pointerup", this.onPointerUp);
      this.addEventListener("pointercancel", this.onPointerUp);
      document.addEventListener("click", this.onDocumentClick);
      this.querySelectorAll(".bundle-sales__series").forEach((series) => {
        series.dataset.scrollMode = String(this.dataset.mode === "scroll");
        const track = series.querySelector("[data-track]");
        if (!track) return;
        const update = () => this.updateArrowState(series);
        track.addEventListener("scroll", update, { passive: true });
        requestAnimationFrame(update);
      });
    }
    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("change", this.onChange);
      this.removeEventListener("pointerdown", this.onPointerDown);
      this.removeEventListener("pointermove", this.onPointerMove);
      this.removeEventListener("pointerup", this.onPointerUp);
      this.removeEventListener("pointercancel", this.onPointerUp);
      document.removeEventListener("click", this.onDocumentClick);
    }
    toggleDropdown(toggle) {
      const dropdown = toggle.closest("[data-product-dropdown]");
      if (!dropdown) return;
      const willOpen = !dropdown.classList.contains("is-open");
      this.closeDropdowns(dropdown);
      dropdown.classList.toggle("is-open", willOpen);
      toggle.setAttribute("aria-expanded", String(willOpen));
    }
    closeDropdowns(except) {
      this.querySelectorAll("[data-product-dropdown].is-open").forEach(
        (dropdown) => {
          if (dropdown === except) return;
          dropdown.classList.remove("is-open");
          dropdown
            .querySelector("[data-dropdown-toggle]")
            ?.setAttribute("aria-expanded", "false");
        },
      );
    }
    selectDropdownItem(item) {
      const dropdown = item.closest("[data-product-dropdown]");
      const card = item.closest("[data-product-card]");
      const handle = item.dataset.productHandle;
      if (!dropdown || !card || !handle) return;
      dropdown
        .querySelectorAll("[data-dropdown-item]")
        .forEach((option) =>
          option.classList.toggle("is-active", option === item),
        );
      const selectedText = dropdown.querySelector(
        "[data-dropdown-selected-text]",
      );
      if (selectedText) selectedText.textContent = item.textContent.trim();
      const select = dropdown.querySelector("[data-product-select]");
      if (select) select.value = handle;
      dropdown.classList.remove("is-open");
      dropdown
        .querySelector("[data-dropdown-toggle]")
        ?.setAttribute("aria-expanded", "false");
      this.loadProduct(card, handle);
    }
    async loadProduct(card, handle) {
      if (!card) return;
      const request = {};
      card.productRequest = request;
      try {
        const root = window.Shopify?.routes?.root || "/";
        const response = await fetch(
          `${root}products/${encodeURIComponent(handle)}.js`,
        ).catch((error) => {
          console.error("Failed to load product:", error);
        });
        if (!response.ok) throw new Error("Product unavailable");
        const product = await response.json();
        if (card.productRequest !== request) return;
        const variant =
          product.variants.find((item) => item.available) ||
          product.variants[0];
        if (!variant) return;
        const template = Array.from(
          card.querySelectorAll("template[data-product-colors]"),
        ).find((item) => item.dataset.productColors === handle);
        const swatches = card.querySelector(".bundle-sales__swatches");
        if (swatches)
          swatches.replaceChildren(
            ...(template ? [template.content.cloneNode(true)] : []),
          );
        const selectedColor = Array.from(
          card.querySelectorAll("[data-color-name]"),
        ).find((item) => String(item.dataset.variantId) === String(variant.id));
        this.updateVariant(card, {
          variantId: variant.id,
          productId: product.id,
          productPrice: variant.price,
          productComparePrice: variant.compare_at_price || 0,
          productImage: variant.featured_image?.src || product.featured_image,
          productInventory: variant.inventory_quantity,
          productInventoryPolicy: variant.inventory_policy,
          productTitle: product.title,
          productHandle: product.handle,
          ...(selectedColor ? selectedColor.dataset : {}),
        });
        card.dataset.productHandle = product.handle;
        card
          .querySelector(".bundle-sales__image-wrap")
          ?.setAttribute(
            "href",
            `${root}products/${encodeURIComponent(handle)}`,
          );
        card.querySelector("[data-product-select]")?.setCustomValidity("");
      } catch (error) {
        if (card.productRequest === request)
          card
            .querySelector("[data-product-select]")
            ?.setCustomValidity(error.message);
      }
    }
    updateColorVariant(colorButton) {
      const card = colorButton.closest("[data-product-card]");
      if (!card) return;

      card
        .querySelectorAll(
          "[data-color-name].is-hovered, [data-color-name].is-selected",
        )
        .forEach((swatch) => {
          swatch.classList.remove("is-hovered", "is-selected");
        });
      colorButton.classList.add("is-hovered", "is-selected");

      this.updateVariant(card, { ...colorButton.dataset });
    }
    updateVariant(card, data) {
      if (!card) return;
      const button = card.querySelector("[data-add-product]");
      const image = card.querySelector("[data-product-image]");
      const title = card.querySelector("[data-product-title]");
      const price = card.querySelector("[data-product-price]");
      const colorLabel = card.querySelector("[data-color-label]");
      if (image && data.productImage) {
        image.src = data.productImage;
        image.srcset = "";
      }
      if (title && data.productTitle) title.textContent = data.productTitle;
      if (colorLabel && data.colorName) colorLabel.textContent = data.colorName;
      if (price && data.productPrice)
        price.innerHTML = `<span>${this.money(Number(data.productPrice))}</span>${Number(data.productComparePrice) > Number(data.productPrice) ? `<s>${this.money(Number(data.productComparePrice))}</s>` : ""}`;
      card
        .querySelectorAll("[data-color-name]")
        .forEach((swatch) =>
          swatch.classList.toggle(
            "is-selected",
            String(swatch.dataset.variantId) === String(data.variantId),
          ),
        );
      if (!button) return;
      // Copy only cart data: swatch attributes also trigger global color styles
      // and swatch click handlers when applied to the Add to Cart button.
      [
        "variantId",
        "productId",
        "productTitle",
        "productHandle",
        "productPrice",
        "productComparePrice",
        "productImage",
        "productInventory",
        "productInventoryPolicy",
      ].forEach((key) => {
        const value = data[key];
        if (value !== undefined && value !== "") button.dataset[key] = value;
      });
      this.cart?.syncProductButtons();
    }
    money(value) {
      return Shopify.formatMoney(value, window.moneyFormat);
    }
    scroll(button) {
      const viewport = button.closest(".bundle-sales__viewport");
      const track = viewport?.querySelector("[data-track]");
      if (track) {
        track.scrollBy({
          left:
            (button.dataset.scroll === "next" ? 1 : -1) *
            track.clientWidth *
            0.8,
          behavior: "smooth",
        });
        window.setTimeout(
          () =>
            this.updateArrowState(viewport.closest(".bundle-sales__series")),
          350,
        );
      }
    }
    updateArrowState(series) {
      const track = series?.querySelector("[data-track]");
      if (!track) return;
      const previous = series.querySelector('[data-scroll="previous"]');
      const next = series.querySelector('[data-scroll="next"]');
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (previous) previous.disabled = track.scrollLeft <= 1;
      if (next)
        next.disabled = track.scrollLeft >= maxScroll - 1 || maxScroll <= 1;
    }
  }

  if (!customElements.get("bundle-sales-cart"))
    customElements.define("bundle-sales-cart", BundleSalesCart);
  if (!customElements.get("bundle-sales-series-list"))
    customElements.define("bundle-sales-series-list", BundleSalesSeriesList);

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.matches?.(".bundle-sales"))
      event.target.querySelector("bundle-sales-cart")?.render();
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (event.target.matches?.(".bundle-sales"))
      event.target.querySelector("bundle-sales-cart")?.disconnectedCallback();
  });
})();
